module.exports = {
  "root": true,
  "project": {
    "name": "SNIK"
  },
  "api": {
    "projectId": "0lkrnbuy",
    "dataset": "production"
  },
  "plugins": [
    "@sanity/base",
    "@sanity/default-layout",
    "@sanity/default-login",
    "@sanity/desk-tool",
    "@sanity/vision"
  ],
  "parts": [
    {
      "name": "part:@sanity/base/schema",
      "path": "./schemas/schema"
    },
    {
      "name": "part:@sanity/desk-tool/structure",
      "path": "./deskStructure.js"
    }
  ]
}



//////////////////
// WEBPACK FOOTER
// ./sanity.json?sanityPart=config%3Asanity
// module id = 84
// module chunks = 0